<script setup name="FieldFormSection">
defineProps({
  dataTest: {
    type: String,
    default: 'form-section',
  },
  title: {
    type: String,
    default: 'Section title',
  },
  accented: {
    type: Boolean,
    default: false,
  },
  full: {
    type: Boolean,
    default: false,
  },
});
</script>

<template>
  <div :data-test="dataTest">
    <div v-if="accented" class="bg-charcoal-1 px-4 py-2 text-secondary-9">
      <p class="text-subtitle-1 text-charcoal-9">{{ title }}</p>
    </div>
    <p class="text-subtitle-1 text-charcoal-9">{{ title }}</p>
    <div
      class="space-y-4"
      :class="{
        'mx-4 mb-8 mt-6': accented,
        'mt-4': !accented,
        'max-w-form': !full,
      }"
    >
      <slot />
    </div>
  </div>
</template>
